export default "__VITE_ASSET__DJOm655K__"